module.exports = __webpack_public_path__ + "img/buildzoom .35a50de3.png";